module.exports = __webpack_public_path__ + "img/CLEAR_DAY_bg.7cb88d64.png";